import React, {useEffect, useMemo} from 'react';
import {CSSTransition} from "react-transition-group";
import Portal from "../../containers/Portal";
import './Popup.scss';
import classNames from "classnames";
import PropTypes from "prop-types";

const Popup = (props) => {
	const { name, title, visible, children, className, onEscape } = props;

	function listenEscapePressed(event) {
		if (event.key === 'Escape') {
			//if esc key was not pressed in combination with ctrl or alt or shift
			const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
			if (isNotCombinedKey) {
				if(typeof onEscape === 'function') {
					console.log('Escape key was pressed with out any group keys')
					onEscape()
				}
			}
		}
	}

	useEffect(() => {
		document.addEventListener('keydown', listenEscapePressed);
		return () => document.removeEventListener('keydown', listenEscapePressed);
	}, [])

	return (
		<Portal id={`${name}-Popup`}>
			<CSSTransition
				in={visible}
				appear={true}
				classNames="fade"
				timeout={700}
				mountOnEnter
				unmountOnExit
			>
				<div className={classNames(['popup-container', className])}>
					<div className="popup-inner">
						<div className="popup-description">
							<p className="popup-title">{title}</p>
							{children}
						</div>
					</div>
				</div>
			</CSSTransition>
		</Portal>
	);
};

export default Popup;

Popup.propTypes = {
	name: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	visible: PropTypes.bool.isRequired,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	className: PropTypes.string,
	onEscape: PropTypes.func,
};